import React, { useState } from 'react';
import { TESTIMONIALS } from '../mock';
import { Quote } from 'lucide-react';

export default function Testimonials() {
  const [hover, setHover] = useState(null);
  return (
    <section className="gradient-bg-light py-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-4">
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#7a1fb0]">O que nossos alunos dizem</h2>
          <p className="text-sm text-[#5a3a6b] mt-2">Passe o mouse sobre um depoimento para ver quem escreveu</p>
          <div className="h-1 w-24 bg-[#ec2fd2] mx-auto mt-4 rounded"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {TESTIMONIALS.map((t, i) => (
            <div key={i}
              className="testimonial-card relative"
              onMouseEnter={()=>setHover(i)}
              onMouseLeave={()=>setHover(null)}
            >
              <Quote className="text-[#ec2fd2] mb-2" size={22} />
              <p className={`text-sm leading-relaxed text-[#3a1450] transition-all duration-300 ${hover === i ? 'blur-sm opacity-50' : ''}`}>{t.text}</p>
              {hover === i && (
                <div className="absolute inset-0 flex flex-col items-center justify-center rounded-2xl bg-white/95 p-6">
                  <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${encodeURIComponent(t.name)}`} alt={t.name} className="w-20 h-20 rounded-full object-cover mb-3 bg-[#f7ecff]" />
                  <div className="text-center">
                    <div className="text-lg font-bold text-[#7a1fb0]">{t.name}</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
